(function () {
    'use strict';

    angular
        .module('jotApp', [
            'ngStorage',
            'tmh.dynamicLocale',
            'pascalprecht.translate',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'infinite-scroll',
            'ui.sortable',
            'ui.select',
            'xeditable',
            'ngSanitize',
            'ngAnimate',
            'ui.load',
            'ui.jq',
            'rzModule',
            'angular-loading-bar',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            'schemaForm',
            'angular-scroll-complete',
            'localytics.directives',
            'chart.js',
            'chartjs-directive',
            'ngTable',
            'nk.touchspin',
            'ui.ace',
            'angular-advanced-searchbox',
            'vcRecaptcha',
            'ja.qr',
            'angularjs-dropdown-multiselect'
        ]).value('THROTTLE_MILLISECONDS', 300).run(run);

    run.$inject = ['stateHandler', 'translationHandler', '$window', '$rootScope', '$location', 'Principal'];

    function run(stateHandler, translationHandler, $window, $rootScope, $location, Principal) {
        $window.ga('create', 'UA-176793938-1', 'auto');
        $rootScope.$on('$stateChangeSuccess', function (event) {
            $window.ga('send', 'pageview', {'page': $location.path()});
        });
        stateHandler.initialize();
        translationHandler.initialize();

        Principal.identity().then(function (data) {
            if (data !== null && data.context !== null) {
                $rootScope.licence = data.context.licence;
                if (data.authorities.length === 4) {
                    $rootScope.licence.id = 4;
                }
            }
        });

        // Functions for dropdown menus in tables

        $(document).on('shown.bs.dropdown', '.table-scrollable', function (e) {
            // The .dropdown container
            var $container = $(e.target);

            // Find the actual .dropdown-menu
            var $dropdown = $container.find('.dropdown-menu');
            if ($dropdown.length) {
                // Save a reference to it, so we can find it after we've attached it to the body
                $container.data('dropdown-menu', $dropdown);

            } else {
                $dropdown = $container.data('dropdown-menu');
            }

            // Hide the dropdown menu if there is one
            $("body > .dropdown-menu").hide();

            // Create the dropdown menu in the DOM
            $dropdown.appendTo('body');

            // Position the dropdown menu relative to the button
            $dropdown.css('top', ($container.offset().top - $dropdown.height() - $container.outerHeight()) + 10 + 'px');
            $dropdown.css('left', ($container.offset().left - $container.width()) + 'px');
            $dropdown.css('display', 'block');
        });

        $(document).on('shown.bs.dropdown', '.table-scrollable-vertical', function (e) {
            // The .dropdown container
            var $container = $(e.target);

            // Find the actual .dropdown-menu
            var $dropdown = $container.find('.dropdown-menu');
            if ($dropdown.length) {
                // Save a reference to it, so we can find it after we've attached it to the body
                $container.data('dropdown-menu', $dropdown);

            } else {
                $dropdown = $container.data('dropdown-menu');
            }

            // Hide the dropdown menu if there is one
            $("body > .dropdown-menu").hide();

            // Create the dropdown menu in the DOM
            $dropdown.appendTo('body');

            // Position the dropdown menu relative to the button
            $dropdown.css('top', ($container.offset().top - $dropdown.height() - $container.outerHeight()) + 10 + 'px');
            $dropdown.css('left', ($container.offset().left - $container.width()) + 'px');
            $dropdown.css('display', 'block');
        });

        $(document).on('hide.bs.dropdown', '.table-scrollable', function (e) {
            // Hide the dropdown menu bound to this button
            $(e.target).data('dropdown-menu').css('display', 'none');
        });

        $(document).on('hide.bs.dropdown', '.table-scrollable-vertical', function (e) {
            // Hide the dropdown menu bound to this button
            $(e.target).data('dropdown-menu').css('display', 'none');
        });

        window.addEventListener('resize', function () {
            // Hide the dropdown menu on window resize
            $("body > .dropdown-menu").hide();
            // Remove class "open" from the button to prevent double click to re-open dropdown menu after window resize
            $(".table-scrollable .table-action-btn-group.open .dropdown-toggle ").dropdown("toggle");
        });

        // Hide the dropdown menu after clicking one of the elements in the list
        $("body").on("click", ".dropdown-menu li a", function () {
            $("body > .dropdown-menu").hide();
        });

        setTimeout(function (){
            // Hide dropdown on table vertical scroll
            $('.table-scrollable-vertical').on("scroll", function (){
                // Hide the dropdown menu on window resize
                $("body > .dropdown-menu").hide();
                // Remove class "open" from the button to prevent double click to re-open dropdown menu after window resize
                $(".table-scrollable-vertical .table-action-btn-group.open .dropdown-toggle ").dropdown("toggle");
                $(".table-scrollable-vertical .table-action-btn-group").removeClass("open");
            });
        }, 1000);
    }
})();
